import { render, staticRenderFns } from "./accordeon.vue?vue&type=template&id=4caec73c"
import script from "./accordeon.js?vue&type=script&lang=js&external"
export * from "./accordeon.js?vue&type=script&lang=js&external"
import style0 from "./accordeon.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports